<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Modifier une offre</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="offreForm" @submit="editOffre" :validation-schema="offreSchema" :initial-values="initialValues">
        <div class="row">

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Catégorie d'offres <span class="text-danger">*</span>
              </label>
              <Field name="categorieOffre" v-slot="{ field }">
                <Multiselect :options="categorieOffresOptions" :searchable="true" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner la catégorie" />
              </Field>
            </div>
            <ErrorMessage name="categorieOffre" class="text-danger" />
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Titre <span class="text-danger">*</span>
              </label>
              <Field name="titre" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le titre" />
              <ErrorMessage name="titre" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Salaire <span class="text-danger">*</span>
              </label>
              <Field name="salaire" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le salaire" />
              <ErrorMessage name="salaire" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Activités <span class="text-danger">*</span>
              </label>
              <Field name="activite" v-slot="{ field }">
                <Multiselect :options="activiteOptions" :searchable="true" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner l'activité" />
              </Field>
            </div>
            <ErrorMessage name="activite" class="text-danger" />
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Prétention salariale <span class="text-danger">*</span>
              </label>
              <Field name="salaire" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le salaire" />
              <ErrorMessage name="salaire" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Commune <span class="text-danger">*</span>
              </label>
              <Field name="commune" v-slot="{ field }">
                <Multiselect :options="communeOptions" :searchable="true" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner la commune" />
              </Field>
            </div>
            <ErrorMessage name="commune" class="text-danger" />
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nombre d'années d'expérience <span class="text-danger">*</span>
              </label>
              <Field name="experience" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nombre" />
              <ErrorMessage name="experience" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nombre de postes disponibles <span class="text-danger">*</span>
              </label>
              <Field name="nombrePoste" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nombre" />
              <ErrorMessage name="nombrePoste" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Indication
              </label>
              <Field name="indication" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le lieu" />
              <ErrorMessage name="indication" class="text-danger" />
            </div>
          </div>
           <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Description <span class="text-danger">*</span>
                  </label>

                  <div class="mb-0">
                    <QuillEditor ref="descriptionEditor" theme="snow" placeholder="Écrivez la description de l'offre"
                      toolbar="full" name="description" />
                  </div>

                  <p class="text-danger" v-if="show === '1'">Ce champ est obligatoire</p>
                </div>
              </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de publication
              </label>
              <Field name="datePublication" type="date" :max="currentDate"
                class="form-control shadow-none fs-md-15 text-black" />
            </div>
            <ErrorMessage name="datePublication" class="text-danger" />
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date d'expiration
              </label>
              <Field name="dateExpiration" type="date" :max="currentDate"
                class="form-control shadow-none fs-md-15 text-black" />
            </div>
            <ErrorMessage name="dateExpiration" class="text-danger" />
          </div>


          <!-- Boutons -->
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center ">
              <button ref="submitButton" class="btn btn-success me-3" type="submit">
                Modifier l'offre
              </button>
              <router-link to="/liste-offres" class=" btn btn-danger">
                Annuler
              </router-link>
            </div>
          </div>

        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { useRouter, useRoute } from "vue-router";
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect'
import { VueTelInput } from 'vue3-tel-input'
import { success, error } from '@/utils/utils';
import { Offre } from '@/models/Offre';
import axios from 'axios';


export default defineComponent({
  name: "EditOffre",
  components: { Form, Field, ErrorMessage, Multiselect },
  setup: () => {
    const route = useRoute();
    const router = useRouter();
    const currentDate = ref(new Date().toISOString().split('T')[0]);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const offreForm = ref<Offre>();

    const activiteOptions = ref([]);
    const communeOptions = ref([]);
    
    const empty = ref("");
    const show = ref("0");
    const showA = ref(false);

     const descriptionEditor = ref<any>(null); // Ref Quill
  const description = ref(''); // Valeur réelle de la description

    const initialValues = ref<any>({}); // valeurs préremplies

    // Schéma de validation (identique à Add)
    const offreSchema = Yup.object().shape({
      categorieOffre: Yup.string()
        .required("La catégorie est obligatoire"),
      titre: Yup.string()
        .required("Le titre est obligatoire"),
      description: Yup.string()
        .required("La description est obligatoire"),
      indication: Yup.string()
        .notRequired(),
      experience: Yup.string()
        .notRequired(),
      activite: Yup.string()
        .required("L'activité est obligatoire"),
      nombrePoste: Yup.string()
        .notRequired(),
      commune: Yup.string()
        .required("La commune est obligatoire"),
      salaire: Yup.string()
        .required("Le salaire est obligatoire"),
      datePublication: Yup.date()
        .required('La date de début est obligatoire')
        .typeError('Veuillez entrer une date valide'),
      dateExpiration: Yup.date()
        .required('La date de fin est obligatoire')
        .typeError('Veuillez entrer une date valide')
        .min(
          Yup.ref('datePublication'),
          'La date de fin doit être postérieure à la date de début'
        ),
    });

    const categorieOffresOptions = ref([]);
    const fetchCategorie = async () => {
      try {
        const response = await axios.get('/categorieOffres');
        const categorieOffresData = response.data.data.data;

        console.log(" Données extraites :", categorieOffresData);

        categorieOffresOptions.value = categorieOffresData.map((categorieOffres) => ({
          value: categorieOffres.id,
          label: `${categorieOffres.libelle}`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchActivite = async () => {
      try {
        const response = await axios.get('/activites');
        const activitesData = response.data.data.data;
        activiteOptions.value = activitesData.map((activites) => ({
          value: activites.id,
          label: `${activites.libelle}`,
        }));
      } catch (error) {
        //
      }
    };


    const fetchCommune = async () => {
      try {
        const response = await axios.get('/communes');
        const communesData = response.data.data.data;
        communeOptions.value = communesData.map((communes) => ({
          value: communes.id,
          label: `${communes.libelle}`,
        }));
      } catch (error) {
        //
      }
    };


    onMounted(() => {
      fetchCategorie();
      fetchActivite();
      fetchCommune();
      if (route.params.id) {
        getOffre(parseInt(route.params.id as string));
      }
    });

    function getOffre(id: number) {
      ApiService.get("/offres/" + id.toString())
        .then(({ data }) => {
          for (const key in data.data) {
            console.log("je suis iciiii", data.data);
            const value = data.data[key];

            if (key === "datePublication") {
              // On garde un format YYYY-MM-DD pour la date
              offreForm.value?.setFieldValue(
                key,
                value ? value.split("T")[0] : null
              );
            } else {
              // Tous les autres champs (y compris ifu)
              offreForm.value?.setFieldValue(
                key,
                typeof value === "object" && value !== null ? value.id : value
              );
            }
             descriptionEditor.value.setHTML(data.data.description);
          for (const key in data.data) {
            offreForm.value?.setFieldValue(key, 
            (typeof data.data[key] === 'object' && data.data[key] !== null)? data.data[key].id :data.data[key]
          );
          }
          }
        })
        .catch(({ response }) => {
          error(response.message);
        });
    }


    const editOffre = async (values) => {
      values['description'] = descriptionEditor.value.getHTML();
      if(values['description'] !== empty.value) {
        showA.value = false;
      }
      else if(values['description'] === empty.value) {
        showA.value = true;
      }
      const id = route.params.id;
      if (submitButton.value) submitButton.value.disabled = true;
      ApiService.put(`/offres/${id}`, values)
        .then(({ data }) => {
          success(data.message);
          router.push({ name: "ListeOffrePage" });
        })
        .catch(({ response }) => {
          submitButton.value!.disabled = false;
          error(response.data.message);
        });
    };

    return {
      offreForm,
      offreSchema,
      editOffre,
      currentDate,
      submitButton, categorieOffresOptions,
      initialValues, activiteOptions, communeOptions,
      descriptionEditor, showA, empty,
      show
    };
  },

  
});
</script>
